// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


function evt2str(strConsumer) {
  return function (evt) {
    return strConsumer(evt.target.value);
  };
}

function evt2bool(boolConsumer) {
  return function (evt) {
    return boolConsumer(evt.target.checked);
  };
}

function evt2click(clickConsumer) {
  return function (evt) {
    clickConsumer({
          ctrl: evt.ctrlKey,
          alt: evt.altKey,
          shift: evt.shiftKey,
          left: evt.button === 0,
          middle: evt.button === 1,
          right: evt.button === 2
        });
  };
}

exports.evt2str = evt2str;
exports.evt2bool = evt2bool;
exports.evt2click = evt2click;
/* No side effect */
